import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function LanguageDropdown() {
    const location = useLocation();
    const navigate = useNavigate();

    // Get language from URL
    const getCurrentLanguage = () => {
        if (location.pathname.startsWith('/en')) return 'en';
        if (location.pathname.startsWith('/hi')) return 'hi';
        return 'hi';
    };

    const [selectedLanguage, setSelectedLanguage] = useState(getCurrentLanguage());

    useEffect(() => {
        const currentLang = getCurrentLanguage();
        if (selectedLanguage !== currentLang) {
            navigate(`/${selectedLanguage}/`, { replace: true });
        }
    }, [selectedLanguage, navigate]);

    const handleLanguageChange = (event) => {
        setSelectedLanguage(event.target.value);
    };

    return (
        <select value={selectedLanguage} onChange={handleLanguageChange}>
            <option value="hi">हिंदी</option>

        </select>
    );
}

export default LanguageDropdown;
